export default "<div class=\"h-100 d-flex justify-content-center align-items-center\">\n  <mat-spinner></mat-spinner>\n</div>\n"